import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './app/App.tsx';
import { ErrorBoundary, initMonitoring } from './lib/monitoring.ts';
import { applySavedBrandColor, initTheme } from './lib/theme.ts';
import { installLicenseGuard } from './services/license.ts';
import { FullScreenMessage, Button } from './ui/index.tsx';
import './index.css';

void initMonitoring();
applySavedBrandColor();
initTheme();
installLicenseGuard();

function Crash() {
  return (
    <FullScreenMessage title="Algo salió mal">
      <p>Tus datos están guardados en este dispositivo. Probá recargar la app.</p>
      <Button onClick={() => location.reload()}>Recargar</Button>
    </FullScreenMessage>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary fallback={<Crash />}>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
